import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-dropdown"
export default class extends Controller {
  static targets = ["toggle", "menu"]

  connect() {
    // Bind the click outside handler to preserve 'this' context
    this.clickOutsideHandler = this.clickOutside.bind(this)
    this.keydownHandler = this.handleKeydown.bind(this)

    // Add global event listeners
    document.addEventListener('click', this.clickOutsideHandler)
    document.addEventListener('keydown', this.keydownHandler)
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('click', this.clickOutsideHandler)
    document.removeEventListener('keydown', this.keydownHandler)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const isOpen = this.toggleTarget.getAttribute('aria-expanded') === 'true'
    this.toggleTarget.setAttribute('aria-expanded', !isOpen)
    this.menuTarget.classList.toggle('show')
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.menuTarget.classList.contains('show')) {
      this.close()
    }
  }

  close() {
    this.toggleTarget.setAttribute('aria-expanded', 'false')
    this.menuTarget.classList.remove('show')
  }
}